import { render, staticRenderFns } from "./FUniswapSwapConfirmation.vue?vue&type=template&id=18e87f36&"
import script from "./FUniswapSwapConfirmation.vue?vue&type=script&lang=js&"
export * from "./FUniswapSwapConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports